<template>
  <div>
    <b-card  :title="$t('ASK_ANALYST.Title')" class="mb-2">
      <custom-g-table
        v-if="displayTable"
        :displayLoading="tableLoading"
        :fields="fields"
        :items="items"
        :limit="limit"
        :totalRows="totalRows"
        @changePage="onChangePage"
        @onSortChange="onSortChange"
        @onColumnFilter="onFilter"
      />
    </b-card>
  </div>
</template>

<script>
import { BCard } from "bootstrap-vue";
import CustomGTable from "@/views/custom/table/CustomGTable.vue";
import askAnalystService from "@/providers/askAnalystService";
// import CustomFilter from "@/views/custom/table/CustomFilter.vue";
import AppConstants from "@/appConstants";
import dropdownService from "@/providers/dropdownService";
import { setRouteQuery, buildParamsRouteQuery } from "@/helpers/route-query-helper";
import { onlyLatestRequest } from "@/helpers/latest-request-helper";

export default {
  props: {
    urlQuery: Object
  },
  components: {
    BCard,
    CustomGTable,
    // CustomFilter,
  },
  data() {
    return {
      displayTable: false,
      sortField: {},
      limit: AppConstants.PAGINATOR_DEFAULT_LIMIT,
      totalRows: 0,
      page: 1,
      filter: {},
      tableLoading: true,
      fields: [
        { field: "client", label: this.$t('ASK_ANALYST.Client'), type: "object", object_field: "email", sortable: false },
        { field: "question", label: this.$t('ASK_ANALYST.Question'), sortable: true, filterOptions: { filterValue: '', enabled: true, placeholder: this.$t('ASK_ANALYST.Question'), trigger: 'enter' } },
        { field: "subject", label: this.$t('ASK_ANALYST.Subject'), sortable: false, type: "object", filterOptions: { filterValue: '', enabled: true, placeholder: this.$t('ASK_ANALYST.Subject'), filterDropdownItems: [] } },
        { field: "origin", label: this.$t('ASK_ANALYST.Origin'), type: "object", sortable: false, filterOptions: { filterValue: '', enabled: true, placeholder: this.$t('ASK_ANALYST.Origin'), filterDropdownItems: [] } },
        { field: "dt_create", label: this.$t('ASK_ANALYST.DtCreate'), type: "custom_date", sortable: true, filterOptions: { filterValue: '', enabled: true, placeholder: this.$t('ASK_ANALYST.DtCreate'), trigger: 'enter' } },
      ],
      /* eslint-disable global-require */
      items: [],
    };
  },
  mounted() {
    this.loadDataFilter();
  },
  computed: {
    searchParams() {
      const params = buildParamsRouteQuery(this.$route.query);
      params.append("page", this.page);
      params.append("limit", this.limit);

      if (this.sortField.field) {
        params.append(`sort_${this.sortField.field}`, this.sortField.type);
      }
      return params;
    },
  },
  methods: {
    setInitialTableFilters() {
      Object.keys(this.urlQuery).forEach(item => {
        this.fields[this.fields.findIndex(val => val.field==item)].filterOptions.filterValue = this.urlQuery[item];
      });
      this.loadData();
    },
    onChangePage(page) {
      this.page = page;
      this.loadData();
    },
    onFilter(data) {
      setRouteQuery(data, this.$route.query);
      this.loadData();
    },
    loadDataFilter() {
      Promise.all([
        dropdownService.getAllOrigin(new URLSearchParams()),
        dropdownService.getAllSubjects(new URLSearchParams()),
      ]).then((res) => {
          const origins = res[0].map(item => {
            return { value: item.id, text: item.name };
          });
          this.fields[this.fields.findIndex(item => item.field=='origin')].filterOptions.filterDropdownItems = origins;
          const subjects = res[1].map(item => {
            return { value: item.id, text: item.name };
          });
          this.fields[this.fields.findIndex(item => item.field=='subject')].filterOptions.filterDropdownItems = subjects;
          this.setInitialTableFilters();
        })
        .catch((err) => console.log(err));
    },
    loadData() {
      this.tableLoading = true;
      onlyLatestRequest(this, 'loadData', askAnalystService.getAllAskAnalystByUser(this.searchParams))
        .then((res) => {
          this.displayTable = true;
          this.tableLoading = false;
          // console.log(res);
          this.items = res.data;
          this.totalRows = res.totalRows;
        })
        .catch((err) => {
          this.displayTable = true;
          console.log(err);
        });
    },
    onSortChange(params) {
      this.sortField = params;
      this.loadData();
    },
  },
};
</script>

<style>
</style>